export default "__VITE_ASSET__DzmWqEl7__"